import React, { useState } from "react";
import "./clientFeedback.css";
import { Helmet } from "react-helmet";

export default function ClientFeedback() {
  const [feedbacks, setFeedbacks] = useState([
    {
      name: "Rahul Verma",
      role: "Honda City Owner",
      feedback:
        "AutoCare Palwal provided outstanding service. My car feels brand new after the maintenance.",
      rating: 5,
    },
    {
      name: "Amit Sharma",
      role: "Hyundai Creta Owner",
      feedback:
        "Professional staff, transparent pricing and quick delivery. Best auto care in Palwal.",
      rating: 5,
    },
  ]);

  const [formData, setFormData] = useState({
    name: "",
    feedback: "",
    rating: 5,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.feedback) return;

    setFeedbacks([
      {
        name: formData.name,
        role: "Verified Customer",
        feedback: formData.feedback,
        rating: formData.rating,
      },
      ...feedbacks,
    ]);

    setFormData({ name: "", feedback: "", rating: 5 });
  };

  return (
    <>
<Helmet>
  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Customer Reviews & Feedback",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Review",
        "reviewBody": "AutoCare Palwal provided outstanding service. My car feels brand new after the maintenance.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": 5,
          "bestRating": 5
        },
        "author": {
          "@type": "Person",
          "name": "Rahul Verma"
        }
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Review",
        "reviewBody": "Professional staff, transparent pricing and quick delivery. Best auto care in Palwal.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": 5,
          "bestRating": 5
        },
        "author": {
          "@type": "Person",
          "name": "Amit Sharma"
        }
      }
    }
  ]
}
`}
</script>

  <title>
    Customer Reviews & Feedback | AutoCare Car Service in Palwal
  </title>

  <meta
    name="description"
    content="Read genuine customer reviews and feedback for AutoCare car service in Palwal. Trusted auto repair experiences from real car owners."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/feedback"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Customer Reviews – AutoCare Palwal"
  />
  <meta
    property="og:description"
    content="Real customer feedback for AutoCare car repair and servicing in Palwal."
  />
</Helmet>

    <section className="feedbackSection">
      <div className="feedbackContainer">

        <h2>What Our Clients Say</h2>
        <p className="subtitle">
          Trusted auto care & car repair services in Palwal — real reviews from real customers
        </p>

        {/* FEEDBACK GRID */}
        <div className="feedbackGrid">
          {feedbacks.map((item, index) => (
            <div className="feedbackCard" key={index}>
              <div className="rating">{"★".repeat(item.rating)}</div>
              <p className="feedbackText">“{item.feedback}”</p>
              <div className="clientInfo">
                <strong>{item.name}</strong>
                <span>{item.role}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ADD FEEDBACK FORM */}
        <div className="addFeedback">
          <h3>Add Your Feedback</h3>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />

            <textarea
              placeholder="Write your experience with AutoCare..."
              value={formData.feedback}
              onChange={(e) =>
                setFormData({ ...formData, feedback: e.target.value })
              }
            ></textarea>

            <select
              value={formData.rating}
              onChange={(e) =>
                setFormData({ ...formData, rating: Number(e.target.value) })
              }
            >
              <option value={5}>★★★★★ Excellent</option>
              <option value={4}>★★★★☆ Good</option>
              <option value={3}>★★★☆☆ Average</option>
            </select>

            <button type="submit">Submit Feedback</button>
          </form>

          <p className="note">
            * Feedback is temporary and for demo purposes only
          </p>
        </div>

      </div>
    </section>
    </>
  );
}
